<template>
    <q-card class="content-between" flat>
        {{model.name}}

        TODO


        <upload
            v-if="isSet"
            :inline="true"
            :small="true"
            :single="true"
            :extensions="extensions"
            @uploaded="(file) => update( file)">

            <q-btn icon v-if="!playing" @click="play">
                <q-icon name="play_arrow"/>
            </q-btn>
            <q-btn icon v-if="playing" @click="stop">
                <q-icon name="stop"/>
            </q-btn>

            <q-btn size="sm" label="Zmień"/>
            <q-btn size="sm" label="Usuń" @click="remove"/>
        </upload>

        <upload
            v-else
            :inline="true"
            :small="true"
            :single="true"
            :extensions="extensions"
            @uploaded="(file) => update(file)">
            <q-btn size="sm" label="Dodaj"/>
        </upload>
    </q-card>
</template>

<script>
    import Upload from './Upload'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'

    export default {
        name: 'VoiceCommandItem',
        data () {
            return {
                extensions: ['.mp3', '.wav', '.ogg'],
                playing: false,
            }
        },
        components: {QIcon, QBtn, Upload},
        props: ['model'],
        methods: {
            update (file) {
                this.$store.dispatch('updateVoicecommand', {
                    ...this.model,
                    file: {
                        id: file.id,
                        name: file.name,
                    },
                })
            },
            play () {
                if (this.isSet) {
                    this.$refs.player.play()
                }
            },
            stop () {
                if (this.isSet) {
                    this.$refs.player.pause()
                    this.$refs.player.currentTime = 0
                    this.stopped()
                }
            },
            played () {
                this.playing=true
            },
            stopped () {
                this.playing=false
            },
            remove () {
                this.$store.dispatch('deleteVoicecommand', this.model)
            }
        },
        computed: {
            isSet () {
                return this.model.file
            },
        },
    }
</script>

<style scoped lang="scss">

</style>